import { fetchPost,fetchGet } from '@/axios/index.js'


export const login = params => { return fetchPost('/admin/user/login',params) }

/**
 * 新增新闻
 * @param {参数} params
 */
export const addNews = params => { return fetchPost('/admin/article/add',params) }


/**
 * 新闻列表
 * @param {} params
 */
export const newsList = params => { return fetchGet('/admin/article/page',params) }

/**
 * 查询文章类别
 */
export const artTyple = () => { return fetchGet('/admin/article/type/get') }

/**
 * 发布文章
 * @param {} params
 */
export const pushArticle = params => { return fetchPost('/admin/article/push',params) }

/**
 * 下架文章
 * @param {} params
 */
export const deleteArticle = params => { return fetchPost('/admin/article/delete',params) }

/**
 * 根据id获取文章
 * @param {} param
 */
export const getArticleById = params => { return fetchGet('/admin/article/get/' + params) }

/**
 * 编辑文章
 */
export const editArticle = params => { return fetchPost('/admin/article/update',params) }

/**
 * 查询管理员
 * @param {} params
 */
export const getUserList = params => { return fetchGet('/admin/user/page',params) }

/**
 * 新增管理员
 * @param {*} params
 */
export const addUser = params => { return fetchPost('/admin/user/add',params) }

/**
 * 启用管理员
 * @param {} params
 */
export const activeUser = params => { return fetchPost('/admin/user/active',params) }

/**
 * 禁用管理员
 * @param {} params
 */
export const forbidUser = params => { return fetchPost('/admin/user/forbid',params) }

/**
 * 修改密码
 * @param {} params
 */
export const updatePassword = params => { return fetchPost('/admin/user/update/password',params) }

/**
 * 退出登录
 */
export const logout = () => { return fetchPost('/admin/user/logout') }

/**
 * 查询收费类型
 */
export const payTypeList = params => { return fetchGet('/admin/pay/type/get', params) }

/**
 * 新增收费类型
 * @param {*} params
 */
export const addPayType = params => { return fetchPost('/admin/pay/type/add',params) }

/**
 * 收费项目查询
 * @param {*} params
 */
export const payItemList = params => { return fetchGet('/admin/pay/item/list', params) }

/**
 * 启用收费项目
 * @param {*} params
 */
export const enabelPayItem = params => { return fetchPost('/admin/pay/item/enable/' + params) }

/**
 * 禁用收费项目
 * @param {*} params
 */
export const forbidPayItem = params => { return fetchPost('/admin/pay/item/stop/' + params) }

/**
 * 新增收费项目
 * @param {*} params
 */
export const addPayItem = params => { return fetchPost('/admin/pay/item/add',params) }

/**
 * 收款记录
 * @param {*} params
 */
export const orderList = params => { return fetchGet('/admin/pay/page', params) }

/**
 * 公众号菜单列表
 */
export const mpMenuList = () => { return fetchGet('/admin/mp/menu/list') }

/**
 * 新增菜单
 * @param {*} params
 */
export const addMpMenu = params => { return fetchPost('/admin/mp/menu/add',params) }

/**
 * 启用公众号菜单
 * @param {*} params
 */
export const activeMpMenu = params => { return fetchPost('/admin/mp/menu/active/' + params) }

/**
 * 禁用菜单
 * @param {*} params
 */
export const forbidMpMenu = params => { return fetchPost('/admin/mp/menu/forbid/' + params) }

/**
 * 修改菜单
 * @param {*} params
 */
export const editMpMenu = params => { return fetchPost('/admin/mp/menu/update',params) }

/**
 * 添加角色
 * @param {*} params
 */
export const addRole = params => { return fetchPost('/admin/role/add',params) }

/**
 * 查询角色列表
 */
export const roleList = () => { return fetchGet('/admin/role/list') }

/**
 * 获取已启用的角色列表
 */
export const roleActiveList = () => { return fetchGet('/admin/role/active/list') }

/**
 * 启用角色
 * @param {*} params
 */
export const activeRole = params => { return fetchPost('/admin/role/active',params) }

/**
 * 禁用角色
 * @param {*} params
 */
export const forbidRole = params => { return fetchPost('/admin/role/forbid',params) }

/**
 * 菜单列表
 */
export const adminMenuList = () => { return fetchGet('/admin/menu/list') }

/**
 * 角色菜单授权
 * @param {*} params
 */
export const addRoleMenu = params => { return fetchPost('/admin/role/menu/add', params) }

/**
 * 获取已授权的菜单
 */
export const getRoleMenuList = params => { return fetchGet('/admin/role/menu/list',params) }

/**
 * 收费汇总
 * @param {*} params
 */
export const orderTotal = params => { return fetchGet('/admin/pay/total',params) }

/**
 * 图片列表
 * @param {*} params
 */
export const imageList = params => { return fetchGet('/admin/img/page',params) }

/**
 * 新增图片
 * @param {*} params
 */
export const addImage = params => { return fetchPost('/admin/img/upload',params) }

/**
 * 启用图片
 * @param {*} params
 */
export const updateImage = params => { return fetchPost('/admin/img/update',params) }

/**
 * 删除图片
 * @param {*} params
 */
export const deleteImage = params => { return fetchPost('/admin/img/delete',params) }
/**
 * 设置图片排序
 * @param {*} params
 */
export const uploadImageLimit = params => { return fetchPost('/admin/img/update/sort',params) }


/**
 * 获取公司列表
 * @returns
 */
export const companyList = () => { return fetchGet('/admin/company/list') }



// WEBPACK FOOTER //
// ./src/axios/api.js